import React from 'react';
import loadable from '@loadable/component';

const SingleBranch = (props) => {
  const Component = loadable(() => import('./SingleBranch.js'), { ssr: false });
  return <Component {...props} />;
};

export default SingleBranch;
